import React, { useEffect, useState } from 'react';
import { ScrollContainer } from 'components';
import { Modal } from 'react-responsive-modal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setData } from 'redux/actions/main';
import { toggleModal } from 'redux/actions/modal';
import { setDataExchange } from 'redux/actions/exchange';
import './index.scss';
import { isElementOverflowing } from 'helper/utils';

const ModalName = 'ModalExchange';

const Exchange = ({ name, toggleModal }) => {
	const closeModal = () => {
		toggleModal(ModalName);
	};
	const { itemList, exchangeToken } = useSelector(
		(state) => ({
			itemList: state.exchange.itemList,
			exchangeToken: state.main.exchangeToken,
		}),
		shallowEqual
	);
	return (
		<Modal
			open={name[ModalName]}
			classNames={{
				modal: `modal modal-exchange`,
				overlay: 'overlay',
				closeButton: 'close-button',
				closeIcon: 'close-icon',
				modalAnimationIn: 'slideInUp',
				modalAnimationOut: 'slideOutDown',
			}}
			animationDuration={250}
			center
			focusTrapped={false}
			onClose={closeModal}
			blockScroll={false}
		>
			<div className="modal-content">
				<ScrollContainer>
					<div className="indicator indicator-token">
						<div className="token">
							<img
								alt=""
								src={process.env.REACT_APP_CDN_URL + 'ico_exchange_token.png'}
							/>
						</div>
						<div className="number">{exchangeToken}</div>
					</div>
					<div className="exchange-list">
						{itemList.map((item) => {
							return <Item key={item.id} data={item} />;
						})}
					</div>
				</ScrollContainer>
			</div>
		</Modal>
	);
};

const Item = ({ data }) => {
	const dispatch = useDispatch();
	const [isOverflow, setOverflow] = useState(false);
	useEffect(() => {
		const el = document.querySelector(`.name-${data.id}`);
		if (el && isElementOverflowing(el)) setOverflow(true);
	}, [data.id]);
	return (
		<div
			onClick={() => {
				dispatch(setData('confirmType', 'exchange'));
				dispatch(setDataExchange('selectedItem', data));
				dispatch(toggleModal('ModalConfirm', true));
			}}
			className={`exchange-item`}
		>
			<div className="item">
				<div className="item-price">
					<img
						alt=""
						src={process.env.REACT_APP_CDN_URL + 'ico_exchange_token.png'}
					/>
					<span className="token-count">x{data.price}</span>
				</div>
				<div className="item-details">
					<span className="item-count">x{data.count}</span>
					<div className={`item-img item-img-${data.id}`}>
						<img alt="" src={data.image} />
					</div>
					<div className="item-name">
						<p className={`name name-${data.id}`}>
                            {/* eslint-disable-next-line  */}
							{isOverflow ? <marquee >{data.item_name}</marquee> : data.item_name}
						</p>
						<p>
							{data.purchase_count}/{data.limit}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Exchange;
